import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-green-50 py-16 md:py-20" data-id="element-73">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.6
      }} className="bg-white border-4 border-green-400 rounded-3xl p-8 sm:p-12 text-center shadow-xl" data-id="element-75">
          <div className="flex justify-center mb-6" data-id="element-76">
            <div className="bg-green-100 p-4 rounded-full" data-id="element-77">
              <Shield className="w-12 h-12 text-green-600" data-id="element-78" />
            </div>
          </div>

          <h2 className="font-fredoka text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-79">
            🔒 Garantía Total de 30 días
          </h2>

          <p className="font-nunito text-lg sm:text-xl text-gray-700 leading-relaxed" data-id="element-80">
            Si por cualquier razón no estás satisfecha con el producto, te
            devolvemos el 100% de tu dinero.
            <span className="font-bold" data-id="element-81">
              {' '}
              Sin preguntas. Sin complicaciones.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}